import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-alert-popover',
  templateUrl: 'alert-popover.html',
  styleUrls: ['alert-popover.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertPopoverPage {
  title: string;
  iconName: string;
  iconColor = 'green';
  content: string;
  imagePath: string;

  constructor(
    public injector: Injector,
    public navParams: NavParams,
    public popoverCtrl: PopoverController) {
    this.title = this.navParams.get('title');
    this.iconName = this.navParams.get('iconName');
    this.imagePath = this.navParams.get('imagePath');
    this.content = this.navParams.get('content');
    this.iconColor = this.navParams.get('iconColor');
  }

  closeMe() {
    this.popoverCtrl.dismiss();
  }
}
